@import '../../../../../../constants/spacing.module.less';

@card-value-font-size: 28px;
@card-value-font-weight: 700;

.modal-wrapper :global(.modal-close-button) svg {
  fill: var(--grey-800);
}

.modal-wrapper :global(.modal-close-button):hover svg {
  fill: var(--grey-900);
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: @space-16;
}

.card-option {
  position: relative;
  padding: @space-16;
  border: 2px solid var(--grey-300);
  border-radius: 8px;
  background: var(--white);
  cursor: pointer;
  transition: all 200ms ease-out;

  &:hover {
    background: var(--grey-50);
  }
}

.card-option-selected {
  border-color: var(--blue-256FEB);
  background: var(--white);
}

.card-option-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.card-option-checkbox {
  position: absolute;
  top: @space-12;
  right: @space-12;
}

.card-option-label {
  color: var(--grey-900);
}

.card-option-value {
  font-size: @card-value-font-size;
  font-weight: @card-value-font-weight;
  color: var(--grey-900);
  line-height: 1.1;
  margin: @space-4 0;
}

.card-option-link {
  color: var(--grey-900);
}

.selection-footer {
  text-align: center;
  color: var(--grey-600);
  font-size: 14px;
  padding-top: @space-8;
  border-top: 1px solid var(--grey-200);
}
